
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f7Vk9", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable jsdoc/check-tag-names */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $hpUsb = parcelRequire("hpUsb");

var $9ISlX = parcelRequire("9ISlX");


var $9CM6e = parcelRequire("9CM6e");


var $eIleF = parcelRequire("eIleF");


var $6CRn4 = parcelRequire("6CRn4");

var $iq4lN = parcelRequire("iq4lN");

var $bWRlG = parcelRequire("bWRlG");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $eIPRD = parcelRequire("eIPRD");


var $f9yl5 = parcelRequire("f9yl5");


var $jVL42 = parcelRequire("jVL42");


var $1zvWv = parcelRequire("1zvWv");


var $3jBhR = parcelRequire("3jBhR");


var $bYRk6 = parcelRequire("bYRk6");


var $eauJy = parcelRequire("eauJy");


var $eQ05w = parcelRequire("eQ05w");

function $19ef7f856d9ae0a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19ef7f856d9ae0a0$var$embedCardWrapperStyles = {
    name: "yjftov",
    styles: "width:100%;height:100%;> div{height:100%;}.loader-wrapper{height:100%;}margin:0 auto"
};
const $19ef7f856d9ae0a0$var$embedCardCenterWrapperStyles = {
    name: "456bw7",
    styles: "margin:24px 0"
};
// Legacy centering when platform_editor_flex_based_centering is off.
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $19ef7f856d9ae0a0$var$uIMediaSingleLayoutStylesLegacy = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
function $19ef7f856d9ae0a0$var$EmbedCardInternal(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, layout: layout, width: width, isInsideOfBlockNode: isInsideOfBlockNode, rendererAppearance: rendererAppearance, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension, onSetLinkTarget: onSetLinkTarget } = props;
    const portal = (0, $eauJy.usePortal)(props);
    const embedIframeRef = (0, $42omo.useRef)(null);
    const onClick = (0, $3jBhR.getCardClickHandler)(eventHandlers, url);
    const { actionOptions: actionOptions } = smartLinks || {};
    const platform = 'web';
    const cardProps = {
        url: url,
        onClick: onClick,
        container: portal,
        platform: platform,
        frameStyle: smartLinks?.frameStyle ?? 'show',
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const [liveHeight, setLiveHeight] = (0, $42omo.useState)(null);
    const [aspectRatio, setAspectRatio] = (0, $42omo.useState)();
    const height = liveHeight || props.originalHeight;
    // We start with height and width defined with default values
    let originalHeight = (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT);
    let originalWidth = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH);
    // Then can override height and width with values from ADF if available
    if (props.originalHeight && props.originalWidth) {
        originalHeight = props.originalHeight;
        originalWidth = props.originalWidth;
    }
    // Then we can override it with aspectRatio that is comming from iframely via `resolve()`
    if (aspectRatio) {
        originalHeight = 1;
        originalWidth = aspectRatio;
    }
    // And finally if iframe sends live `height` events we use that as most precise measure.
    const isHeightOnlyMode = !(props.originalHeight && props.originalWidth) || liveHeight;
    if (height && isHeightOnlyMode) {
        originalHeight = height;
        originalWidth = undefined;
    }
    const padding = rendererAppearance === 'full-page' ? (0, $1zvWv.FullPagePadding) * 2 : 0;
    const [hasPreview, setPreviewAvailableState] = (0, $42omo.useState)(true);
    const cardContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const onResolve = ({ aspectRatio: resolvedAspectRatio })=>{
        const hasPreviewOnResolve = !!(cardContext && url && cardContext.extractors.getPreview(url, platform));
        if (!hasPreviewOnResolve) setPreviewAvailableState(false);
        setAspectRatio(resolvedAspectRatio);
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: documentWidth })=>{
        const isFullWidth = rendererAppearance === 'full-width';
        let containerWidth = documentWidth;
        if (smartLinks?.ssr && !containerWidth) // EDM-8114: When we are rendering on SSR, we have no idea what the width is.
        containerWidth = isFullWidth ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : (0, $aFUXX.akEditorDefaultLayoutWidth);
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $aFUXX.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $aFUXX.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const lineLength = isFullWidth ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), containerWidth - padding) : nonFullWidthSize;
        const useStickySafeCentering = (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? useStickySafeCentering ? undefined : $19ef7f856d9ae0a0$var$uIMediaSingleLayoutStylesLegacy : '';
        const onError = ({ err: err })=>{
            if (err) throw err;
        };
        let cardComponent;
        if (smartLinks?.ssr && url && ((0, $dh538.fg)('platform_ssr_smartlink_embeds') || (0, $dh538.fg)('jfp-magma-ssr-iv-editor-links'))) {
            const ssrCardProps = {
                url: url,
                onClick: onClick,
                container: portal,
                platform: platform,
                frameStyle: smartLinks?.frameStyle ?? 'show',
                actionOptions: actionOptions
            };
            cardComponent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9CM6e.CardSSR), {
                appearance: "embed",
                ...ssrCardProps,
                onResolve: onResolve,
                inheritDimensions: true,
                embedIframeRef: embedIframeRef,
                onError: onError
            });
        } else cardComponent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hpUsb.Card), {
            appearance: "embed",
            ...cardProps,
            onResolve: onResolve,
            inheritDimensions: true,
            embedIframeRef: embedIframeRef,
            onError: onError
        });
        return(// Ignored via go/ees005
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f9yl5.SmartLinkDraggable), {
            url: url || '',
            appearance: (0, $f9yl5.SMART_LINK_APPEARANCE).EMBED,
            source: (0, $f9yl5.SMART_LINK_DRAG_TYPES).RENDERER
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIPRD.CardErrorBoundary), {
            unsupportedComponent: (0, $iq4lN.default),
            onSetLinkTarget: onSetLinkTarget,
            ...cardProps
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9ISlX.EmbedResizeMessageListener), {
            embedIframeRef: embedIframeRef,
            onHeightUpdate: setLiveHeight
        }, (()=>{
            const useCenterWrapper = (layout === 'full-width' || layout === 'wide') && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
            const mediaSingle = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6CRn4.default), {
                css: uiMediaSingleStyles,
                layout: layout,
                width: originalWidth,
                containerWidth: containerWidth,
                pctWidth: width,
                height: originalHeight,
                fullWidthMode: isFullWidth,
                nodeType: "embedCard",
                lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
                hasFallbackContainer: hasPreview,
                isInsideOfInlineExtension: isInsideOfInlineExtension
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: $19ef7f856d9ae0a0$var$embedCardWrapperStyles,
                "data-vc": "N550oPSa"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "embedCardView-content-wrap",
                "data-embed-card": true,
                "data-layout": layout,
                "data-width": width,
                "data-card-data": data ? JSON.stringify(data) : undefined,
                "data-card-url": url,
                "data-card-original-height": originalHeight
            }, cardComponent)));
            return useCenterWrapper ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER,
                css: $19ef7f856d9ae0a0$var$embedCardCenterWrapperStyles
            }, mediaSingle) : mediaSingle;
        })()))));
    }));
}
const $19ef7f856d9ae0a0$export$1135f3b0aac4c4ec = ({ url: url, data: data, eventHandlers: eventHandlers, portal: portal, originalHeight: originalHeight, originalWidth: originalWidth, width: embedWidth, layout: layout, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension, onSetLinkTarget: onSetLinkTarget })=>{
    const { width: width } = (0, $42omo.useContext)((0, $bWRlG.WidthContext));
    const viewAsBlockCard = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eQ05w.default), {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        layout: layout,
        rendererAppearance: rendererAppearance,
        smartLinks: smartLinks,
        onSetLinkTarget: onSetLinkTarget
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)($19ef7f856d9ae0a0$var$EmbedCardInternal, {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        originalHeight: originalHeight,
        originalWidth: originalWidth,
        width: embedWidth,
        layout: layout,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        smartLinks: smartLinks,
        isInsideOfInlineExtension: isInsideOfInlineExtension,
        onSetLinkTarget: onSetLinkTarget
    });
};
const $19ef7f856d9ae0a0$var$EmbedCardWithCondition = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $19ef7f856d9ae0a0$export$1135f3b0aac4c4ec, $19ef7f856d9ae0a0$var$EmbedCardInternal);
var $19ef7f856d9ae0a0$export$2e2bcd8739ae039 = $19ef7f856d9ae0a0$var$EmbedCardWithCondition;
module.exports["default"] = $19ef7f856d9ae0a0$export$2e2bcd8739ae039;

});

parcelRegister("9ISlX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d6477c19fa37ad04$export$8f5a73ba0d077b01 = 32;
class $d6477c19fa37ad04$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $d6477c19fa37ad04$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}
module.exports["embedHeaderHeight"] = $d6477c19fa37ad04$export$8f5a73ba0d077b01;
module.exports["EmbedResizeMessageListener"] = $d6477c19fa37ad04$export$3482036c37e627f4;

});

parcelRegister("2daQU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("fBAKC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("69fUv")));
const $7850275dc402dd65$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
            ...props
        })
    });
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $7850275dc402dd65$export$f386473e8f104bcb;

});

parcelRegister("69fUv", function(module, exports) {

let $479fecd0aea59d37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $479fecd0aea59d37$var$load("koKgZ").then(()=>parcelRequire('7Fmwh'));

});

parcelRegister("7FiWH", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $lOzEN = parcelRequire("lOzEN");


var $8tdj3 = parcelRequire("8tdj3");


var $jypE9 = parcelRequire("jypE9");


var $dh538 = parcelRequire("dh538");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $iGbqR = parcelRequire("iGbqR");

var $d925B = parcelRequire("d925B");


var $3RxtY = parcelRequire("3RxtY");

function $f7a722354e8e82d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $f7a722354e8e82d7$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f7a722354e8e82d7$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $f7a722354e8e82d7$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $f7a722354e8e82d7$var$linkStylesCommon = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $f7a722354e8e82d7$var$ICON_WIDTH = 16;
const $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $f7a722354e8e82d7$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $f7a722354e8e82d7$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const containerRef = (0, $42omo.useRef)(null);
    const hoverLinkButtonRef = (0, $42omo.useRef)(null);
    const hiddenTextRef = (0, $42omo.useRef)(null);
    const [showLabel, setShowLabel] = (0, $42omo.useState)(true);
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const openTextWidthRef = (0, $42omo.useRef)(null);
    const regularPadding = (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK : "var(--ds-space-025, 2px)";
    const memoizedHoverLinkStyles = (0, $42omo.useMemo)(()=>({
            paddingBlock: compactPadding ? '1px' : regularPadding
        }), [
        compactPadding,
        regularPadding
    ]);
    const hoverLinkStyles = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedHoverLinkStyles : {
        paddingBlock: compactPadding ? '1px' : (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK : "var(--ds-space-025, 2px)"
    };
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $f7a722354e8e82d7$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if ((0, $iu6m9.editorExperiment)('cc_editor_hover_link_overlay_css_fix', true)) {
            if (containerRef.current && hoverLinkButtonRef.current) {
                const containerRight = containerRef.current.getBoundingClientRect().right;
                const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
                if (buttonRight > containerRight) canShowLabel = false;
            }
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if ((0, $iu6m9.editorExperiment)('cc_editor_hover_link_overlay_css_fix', true)) {
            if (isHovered) setShowLabel(true);
        }
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $f7a722354e8e82d7$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $3RxtY.messages).previewButtonTitle) : formatMessage((0, $3RxtY.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: containerRef,
        css: $f7a722354e8e82d7$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        "data-vc": "rRfPmPn6"
    }, children, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $f7a722354e8e82d7$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fpGTa.default), {
        ref: hoverLinkButtonRef,
        xcss: $f7a722354e8e82d7$var$linkStylesCommon,
        href: url,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic paddingBlock value based on experiment flags
        style: hoverLinkStyles,
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $f7a722354e8e82d7$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $f7a722354e8e82d7$export$2e2bcd8739ae039 = $f7a722354e8e82d7$var$HoverLinkOverlay;
module.exports["default"] = $f7a722354e8e82d7$export$2e2bcd8739ae039;

});


//# sourceMappingURL=embedCard.99dc74ff.js.map
